import React, { useEffect, useState } from 'react'
import { Card, Form, Row, Col, Button, Container, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addInventory, listInventory } from '../actions/inventoryActions'
import { useNavigate, Link } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { getItemsall } from '../actions/itemActions'
import { getAllnames } from '../actions/nameActions'

const InventoryUnit = () => {
  const [upc, setUpc] = useState('')
  const [manufacturers, setName] = useState('')
  const [subname, setSubname] = useState('')
  const [item, setItem] = useState('')
  const [qty, setQty] = useState('')
  const [lowinventory, setLowinventory] = useState('')
  const [cost, setCost] = useState('')
  const [price, setPrice] = useState('')

  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })

  function showAlert(message, variant = 'success', seconds = 1000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const inventoryAdd = useSelector((state) => state.inventoryAdd)
  const { loading, error, success } = inventoryAdd

  const itemListAll = useSelector((state) => state.itemListAll)
  const { itemsall } = itemListAll

  const nameAll = useSelector((state) => state.nameAll)
  const { manufacturer } = nameAll

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const onSubmit = (e) => {
    e.preventDefault()

    const itemadded = {
      upc: upc,
      manufacturer: manufacturers,
      subname: subname,
      item: item,
      qty: qty,
      lowinventory: lowinventory,
      cost: cost,
      price: price,
      cid: userInfo.cid
    }

    if (
      upc === '' ||
      manufacturer === '' ||
      subname === '' ||
      item === '' ||
      qty === '' ||
      lowinventory === '' ||
      cost === '' ||
      price === ''
    ) {
      showAlert('Please fill in all fields', 'danger')
      return
    } else if (qty <= 0) {
      showAlert('Quantity cannot be less than or equal to 0', 'danger')
      return
    } else {
      if (window.confirm('Are you sure you want to add this item?')) {
        dispatch(addInventory(itemadded))
        showAlert('Item Added', 'success')
        setUpc('')
        setName('')
        setSubname('')
        setItem('')
        setQty('')
        setLowinventory('')
        setCost('')
        setPrice('')
        dispatch({ type: 'INVENTORY_ADD_RESET' })
        dispatch({ type: 'INVENTORY_DETAILS_RESET' })
      }
    }
  }

  useEffect(() => {
    if (userInfo) {
      dispatch(getItemsall())
      dispatch(getAllnames())
    } else {
      navigate('/login')
    }
  }, [dispatch, navigate, userInfo])

  useEffect(() => {
    if (success && userInfo) {
      dispatch({ type: 'INVENTORY_ADD_RESET' })
      navigate('/inventory')
      dispatch(listInventory())
    }
  }, [dispatch, navigate, success, userInfo])

  useEffect(() => {
    if (!userInfo) {
      navigate('/login')
    }
  }, [navigate, userInfo])

  // useEffect(() => {
  //   dispatch(getItemsall())
  //   dispatch(getAllnames())
  //   if (userInfo && success) {
  //     dispatch({ type: 'INVENTORY_ADD_RESET' })
  //     navigate('/inventory')
  //     dispatch(listInventory())
  //   } else if (!userInfo) {
  //     dispatch({ type: 'INVENTORY_ADD_RESET' })
  //     window.location.reload()
  //     navigate('/login')
  //   }
  // }, [dispatch, navigate, userInfo, success])

  const itemlist = Object.keys(itemsall).map((key) => {
    return (
      <option key={key} value={itemsall[key].item}>
        {itemsall[key].item}
      </option>
    )
  }, this)

  const nameslist = manufacturer.map((name) => {
    return (
      <option key={name._id} value={name.manufacturer}>
        {name.manufacturer}
      </option>
    )
  }, this)

  return (
    <Container>
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {error && <Message variant='danger'>{error}</Message>}
      {loading && <Loader />}
      <Row className='my-3'>
        <Col>
          <Link to='/inventory' className='btn btn-info btn-sm my-2'>
            Go Back
          </Link>
        </Col>
      </Row>
      <h3>Add Inventory Entry</h3>
      <Card className='mt-3 mb-3'>
        <Card.Body>
          <Form onSubmit={onSubmit}>
            <Row className='my-2'>
              <Col>
                <Form.Label htmlFor='upc'>UPC</Form.Label>
                <Form.Group controlId='upc'>
                  <Form.Control
                    placeholder='UPC'
                    value={upc}
                    onChange={(e) => setUpc(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Label htmlFor='item'>Item</Form.Label>
                <Form.Group controlId='item'>
                  <Form.Control
                    defaultValue={item}
                    as='select'
                    autoComplete='on'
                    onChange={(e) => setItem(e.target.value)}
                  >
                    {itemlist}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-2'>
              <Col>
                <Form.Label htmlFor='name'>Manufacturer</Form.Label>
                <Form.Group controlId='name'>
                  <Form.Control
                    as='select'
                    defaultValue={manufacturers}
                    autoComplete='on'
                    onChange={(e) => setName(e.target.value)}
                  >
                    {nameslist}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Label htmlFor='subname'>Subname</Form.Label>
                <Form.Group controlId='subname'>
                  <Form.Control
                    placeholder='Subname'
                    value={subname}
                    onChange={(e) => setSubname(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-2'>
              <Col>
                <Form.Label htmlFor='qty'>Quantity</Form.Label>
                <Form.Group controlId='qty'>
                  <Form.Control
                    placeholder='Qty'
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Label htmlFor='price'>Low Inventory Level</Form.Label>
                <Form.Group controlId='lowinventory'>
                  <Form.Control
                    type='number'
                    className='w-25'
                    min='0'
                    step='1'
                    placeholder='0'
                    value={lowinventory}
                    onChange={(e) => setLowinventory(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='my-2'>
              <Col>
                <Form.Label htmlFor='price'>Cost</Form.Label>
                <Form.Group controlId='cost'>
                  <Form.Control
                    type='number'
                    min='0.01'
                    step='0.01'
                    placeholder='Cost'
                    value={cost}
                    onChange={(e) => setCost(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Label htmlFor='price'>Price</Form.Label>
                <Form.Group controlId='price'>
                  <Form.Control
                    type='number'
                    min='0.01'
                    step='0.01'
                    placeholder='Price'
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='my-2'>
              <Col>
                <Button variant='secondary' type='submit' size='sm'>
                  Save
                </Button>{' '}
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  )
}

export default InventoryUnit
